import { useState } from 'react'
import GoogleIcon from '@/components/icons/GoogleIcon'
import { VITE_API_URL } from '@/env'
import { leavePage } from '@/lib/pageNavigation'
import { BASE_URL } from '@/services/api'
import { PATHS } from '@/services/endpoints'
import { Spinner, Button } from '@heroui/react'

export default function GoogleSigninButton({ disabled }: { disabled?: boolean }) {
	const [isLoading, setIsLoading] = useState(false)

	const handleClick = () => {
		if (isLoading) return
		setIsLoading(true)

		const candidate =
			(typeof VITE_API_URL === 'function' ? VITE_API_URL() : VITE_API_URL) || BASE_URL || ''
		const base = String(candidate).replace(/\/$/, '')
		const target = base ? `${base}${PATHS.auth.google}` : PATHS.auth.google

		leavePage(target)
	}

	return (
		// The ripple lazily imports its animation chunk on press. This press also leaves the
		// page, and WebKit aborts that import as soon as the navigation starts, which surfaced
		// as "Importing a module script failed" on iOS, so the ripple is disabled here.
		<Button
			disableRipple
			size="lg"
			variant="solid"
			isDisabled={disabled || isLoading}
			aria-label="Continue with Google"
			aria-busy={isLoading}
			onPress={handleClick}
			className="inline-flex w-full max-w-xl items-center justify-center gap-4 rounded-2xl bg-zinc-900 px-6 py-3 text-white hover:opacity-95 disabled:opacity-60"
		>
			<span className="flex h-8 w-8 items-center justify-center">
				{isLoading ? <Spinner size="sm" /> : <GoogleIcon size={20} />}
			</span>
			<span className="text-lg font-medium">
				{isLoading ? 'Signing in...' : 'Continue with Google'}
			</span>
		</Button>
	)
}
